import React from "react";
import { observer } from "mobx-react-lite";
import { Box, theme } from "Application";
import { ExclamationIconSVG } from "../Assets/Icons/ExclamationIconSVG";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css"; // optional

interface Props {
    haveError: boolean;
    displayName?: string;
    validationMessage: () => string;
    style?: any;
}
export const ErrorExclamationView: React.FC<Props> = observer((props: Props) => {
    return (
        <Box display={"flex"} ml={1} style={{ visibility: props.haveError ? "visible" : "hidden" }}>
            <Box mt={"-3px"}>
                <Tippy content={<span>{props.validationMessage()}</span>} disabled={!props.haveError}>
                    <ExclamationIconSVG color={"white"} style={{ outline: "none" }} backgroundcolor={theme.palette.error.main} />
                </Tippy>
            </Box>
        </Box>
    );
});
